import React, { Component } from "react";
import Table from "./../common/table";
import { Link, withRouter } from "react-router-dom";

class ScrumMastersTable extends Component {
	// constructor(props) {
	// 	super(props);
	// 	this.state = {
	// 		values: [],
	// 	};
	// }

	columns = [
		//   {path: '_id', label: 'Id'},
		{
			key: "checkbox",
			label: (
				<input
					type="check"
					style={{
						width: "15px",
						height: "15px",
						marginTop: "0.4rem",
						borderRadius: 0,
					}}
				/>
			),
			content: (scrummaster) => (
				<span className="icon-img sm-r-5" style={{ marginTop: "15px" }}>
					<input
						type="checkbox"
						style={{
							width: "15px",
							height: "15px",
							marginTop: "0.4rem",
							borderRadius: 0,
						}}
						onChange={this.props.handleCheckboxChange}
						value={scrummaster._id}
					/>
				</span>
			),
		},
		{
			key: "avatar",
			label: "avatar",
			content: (user) => (
				<span className="icon-img sm-r-5">
					<img
						style={{ width: "30px", height: "30px", borderRadius: "50%" }}
						src={user.imageSrc}
						alt=""
					/>
				</span>
			),
		},
		{label: 'Username',   path: 'scrummasters.username' } ,
		{label: 'Firstname',   path: 'scrummasters.contactName.first' } ,   
		{label: 'Initials',   path: 'scrummasters.contactName.initials' } ,   	  
		{label: 'Lastname',   path: 'scrummasters.contactName.last' } ,   	  
		{label: 'DOB',   path: 'scrummasters.dateBirth' } ,   	  
		{label: 'Gender',   path: 'scrummasters.gender' } ,   	  
		{label: 'Address1',   path: 'scrummasters.Address.address1' } ,   
		{label: 'Address2',   path: 'scrummasters.Address.address2' } ,   
		{label: 'Address3',   path: 'scrummasters.Address.address3' } ,           
		{label: 'Zip',   path: 'scrummasters.Address.zip' } ,   	  
		{label: 'City',   path: 'scrummasters.Address.city' } ,   	      
		{label: 'State',   path: 'scrummasters.Address.state' } ,   	          
		{label: 'Country',   path: 'scrummasters.Address.country' } ,   	  	  
		{label: 'Linkedin',   path: 'scrummasters.linkedin' } ,       
		{label: 'Mobile',   path: 'scrummasters.phones.mobile' } ,   	  
		{label: 'Phone',   path: 'scrummasters.phones.phone' } ,   	  
		{label: 'Skype',   path: 'scrummasters.phones.skype' } , 
		{label: 'IBAN',   path: 'scrummasters.bankInfo.IBAN' } ,   
		{label: 'Bank',   path: 'scrummasters.bankInfo.bank' } ,   
		{label: 'Branch Bank',   path: 'scrummasters.bankInfo.branchOfBank' } ,   
		{label: 'Company',   path: 'clinicSolo' } ,   
		{label: 'ID-Paper',   path: 'scrummasters.identification.idPaper' } ,   	  
		{label: 'ID-Paper Valid Till',   path: 'scrummasters.identification.idPaperValidTill' } , 
		{label: 'Treatments',   path: 'scrummasters.treatments' } ,   	  	
		{label: 'LicenseNo',   path: 'scrummasters.licenseNo' } ,   	  
		{label: 'License Valid Till',   path: 'scrummasters.licenseValidTill' } ,   	      
		{label: 'OrganizationA Name',   path: 'scrummasters.organizationAName' } ,   	          
		{label: 'OrganizationA Member No',   path: 'scrummasters.organizationAMemberNo' } ,   	  	  
		{label: 'OrganizationB Name',   path: 'scrummasters.organizationBName' } ,   	          
		{label: 'OrganizationB Member No',   path: 'scrummasters.organizationBMemberNo' } ,   	  	  
	];

	render() {
		//console.log(this.columns) ;
		const { scrummasters, onSort, sortColumn } = this.props;
		return (
			<Table
				columns={this.columns}
				sortColumn={sortColumn}
				onSort={onSort}
				data={scrummasters}
			/>
		);
	}
}

export default ScrumMastersTable;
